export const featureDefinitions = {
  // TRACKING & MONITORING
  'asin-tracking': {
    id: 'asin-tracking',
    name: 'Additional ASIN Tracking',
    description: 'Track 500 more ASINs for sales rank and performance monitoring',
    shortDescription: '+500 tracked ASINs',
    category: 'tracking',
    price: 20,
    unit: '500 ASINs',
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    stackable: true,
    maxStacks: 20,
    benefits: [
      'Monitor 500 additional ASINs',
      'Sales rank tracking',
      'Performance alerts',
      'Historical data',
    ],
    usageType: 'limit',
  },
  'search-term-tracking': {
    id: 'search-term-tracking',
    name: 'Additional Search Term Tracking',
    description: 'Track 500 more search terms for keyword discovery and optimization',
    shortDescription: '+500 search terms',
    category: 'tracking',
    price: 20,
    unit: '500 Search Terms',
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    stackable: true,
    maxStacks: 20,
    benefits: [
      'Track 500 additional search terms',
      'Keyword discovery',
      'Performance monitoring',
      'Conversion tracking',
    ],
    usageType: 'limit',
  },

  // TESTING & OPTIMIZATION
  'creative-ab-testing': {
    id: 'creative-ab-testing',
    name: 'Creative A/B Testing',
    description: 'Split test ad creatives with statistical significance tracking',
    shortDescription: 'A/B test creatives',
    category: 'testing',
    price: 39,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Statistical significance testing',
      'Automated traffic splitting',
      'Performance comparison',
      'Winner auto-promotion',
    ],
    usageType: 'feature',
  },
  'campaign-ab-testing': {
    id: 'campaign-ab-testing',
    name: 'Campaign A/B Testing',
    description: 'Test campaign strategies and bid approaches',
    shortDescription: 'A/B test campaigns',
    category: 'testing',
    price: 49,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Campaign strategy testing',
      'Bid approach comparison',
      'Budget allocation testing',
      'Performance insights',
    ],
    usageType: 'feature',
  },
  'landing-page-testing': {
    id: 'landing-page-testing',
    name: 'Landing Page Testing',
    description: 'Test different product pages for conversion optimization',
    shortDescription: 'Landing page A/B tests',
    category: 'testing',
    price: 29,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Product page testing',
      'Conversion optimization',
      'Traffic routing',
      'Performance analytics',
    ],
    usageType: 'feature',
  },

  // AUTOMATION & INTELLIGENCE
  'keyword-harvesting': {
    id: 'keyword-harvesting',
    name: 'Automatic Keyword Harvesting',
    description: 'AI-powered discovery of profitable keywords from search terms',
    shortDescription: 'Auto keyword discovery',
    category: 'automation',
    price: 39,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Save 10+ hours per week',
      'Discover 300% more keywords',
      'AI-powered relevance scoring',
      'Automated campaign addition',
    ],
    usageType: 'feature',
  },
  'searchterm-negation': {
    id: 'searchterm-negation',
    name: 'Smart Search Term Negation',
    description: 'AI-powered negative keyword suggestions and automation',
    shortDescription: 'Auto negative keywords',
    category: 'automation',
    price: 29,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Reduce wasted spend by 25%',
      'AI-powered suggestions',
      'Automatic implementation',
      'Performance monitoring',
    ],
    usageType: 'feature',
  },
  'campaign-scheduling': {
    id: 'campaign-scheduling',
    name: 'Campaign/AdGroup/Ad/Target Scheduling',
    description: 'Schedule pause/enable actions for campaigns, ad groups, ads, and targets',
    shortDescription: 'Advanced scheduling',
    category: 'automation',
    price: 34,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Schedule any entity',
      'Custom time zones',
      'Recurring schedules',
      'Bulk operations',
    ],
    usageType: 'feature',
  },
  dayparting: {
    id: 'dayparting',
    name: 'Automatic Dayparting',
    description: 'Optimize ad schedules by time of day automatically',
    shortDescription: 'Auto dayparting',
    category: 'automation',
    price: 44,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Increase ROI by 15-30%',
      'AI-powered optimization',
      'Custom time zones',
      'Performance tracking',
    ],
    usageType: 'feature',
  },
  'weekday-parting': {
    id: 'weekday-parting',
    name: 'Weekday/Weekend Parting',
    description: 'Separate strategies for weekdays vs weekends',
    shortDescription: 'Weekday optimization',
    category: 'automation',
    price: 24,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Optimize for weekend vs weekday',
      'Different bid strategies',
      'Automatic adjustments',
      'Performance comparison',
    ],
    usageType: 'feature',
  },
  'seasonal-automation': {
    id: 'seasonal-automation',
    name: 'Seasonal Campaign Automation',
    description: 'Auto-adjust campaigns for seasonal trends and events',
    shortDescription: 'Seasonal optimization',
    category: 'automation',
    price: 54,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Holiday optimization',
      'Seasonal trend detection',
      'Automatic bid adjustments',
      'Inventory coordination',
    ],
    usageType: 'feature',
  },
  'budget-reallocation': {
    id: 'budget-reallocation',
    name: 'Automatic Budget Reallocation',
    description: 'Automatically shift budgets to top-performing campaigns',
    shortDescription: 'Auto budget optimization',
    category: 'automation',
    price: 64,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Maximize campaign performance',
      'Real-time budget shifts',
      'ROI-based allocation',
      'Performance tracking',
    ],
    usageType: 'feature',
  },

  // CAMPAIGN MANAGEMENT
  'bulk-creative-copying': {
    id: 'bulk-creative-copying',
    name: 'Bulk Creative Copying',
    description: 'Copy creatives to new or existing campaigns in bulk',
    shortDescription: 'Bulk creative operations',
    category: 'management',
    price: 19,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Save hours of manual work',
      'Cross-campaign scaling',
      'Template management',
      'Bulk modifications',
    ],
    usageType: 'feature',
  },
  'bulk-target-migration': {
    id: 'bulk-target-migration',
    name: 'Bulk Target/Negative Migration',
    description: 'Move targets and negatives between campaigns efficiently',
    shortDescription: 'Bulk target operations',
    category: 'management',
    price: 24,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Efficient campaign management',
      'Bulk operations',
      'Historical preservation',
      'Performance tracking',
    ],
    usageType: 'feature',
  },
  'campaign-templates': {
    id: 'campaign-templates',
    name: 'Campaign Template System',
    description: 'Save and reuse campaign structures and strategies',
    shortDescription: 'Campaign templates',
    category: 'management',
    price: 29,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Standardize campaign creation',
      'Best practice templates',
      'Quick deployment',
      'Team collaboration',
    ],
    usageType: 'feature',
  },
  'marketplace-sync': {
    id: 'marketplace-sync',
    name: 'Multi-Marketplace Sync',
    description: 'Sync campaigns across different Amazon regions',
    shortDescription: 'Multi-region sync',
    category: 'management',
    price: 39,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Global campaign management',
      'Currency conversion',
      'Regional optimization',
      'Unified reporting',
    ],
    usageType: 'feature',
  },
  'competitive-cloning': {
    id: 'competitive-cloning',
    name: 'Competitive Campaign Cloning',
    description: 'Replicate successful competitor strategies',
    shortDescription: 'Competitor analysis',
    category: 'management',
    price: 49,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Competitor intelligence',
      'Strategy replication',
      'Market research',
      'Performance benchmarking',
    ],
    usageType: 'feature',
  },

  // ADVANCED ANALYTICS
  'profit-analytics-pro': {
    id: 'profit-analytics-pro',
    name: 'Profit Analytics Pro',
    description: 'Advanced profit tracking with COGS and detailed attribution',
    shortDescription: 'Advanced profit tracking',
    category: 'analytics',
    price: 59,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'True profit calculations',
      'COGS integration',
      'Attribution modeling',
      'ROI optimization',
    ],
    usageType: 'feature',
  },
  'market-share-analysis': {
    id: 'market-share-analysis',
    name: 'Market Share Analysis',
    description: 'Track your position vs competitors in your market',
    shortDescription: 'Market positioning',
    category: 'analytics',
    price: 44,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Competitive positioning',
      'Market trends',
      'Share of voice',
      'Growth opportunities',
    ],
    usageType: 'feature',
  },
  'keyword-rank-tracking': {
    id: 'keyword-rank-tracking',
    name: 'Keyword Rank Tracking',
    description: 'Monitor organic and sponsored keyword rankings',
    shortDescription: 'Rank monitoring',
    category: 'analytics',
    price: 34,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Organic rank tracking',
      'Sponsored position monitoring',
      'Rank improvement alerts',
      'Competitor comparison',
    ],
    usageType: 'feature',
  },
  'attribution-modeling': {
    id: 'attribution-modeling',
    name: 'Multi-Touch Attribution',
    description: 'Advanced attribution modeling for customer journeys',
    shortDescription: 'Attribution analysis',
    category: 'analytics',
    price: 49,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Customer journey mapping',
      'Touch point analysis',
      'Credit distribution',
      'ROI optimization',
    ],
    usageType: 'feature',
  },
  'cohort-analysis': {
    id: 'cohort-analysis',
    name: 'Customer Cohort Analysis',
    description: 'Track customer lifetime value and retention',
    shortDescription: 'Customer LTV tracking',
    category: 'analytics',
    price: 39,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: [
      'Lifetime value calculation',
      'Retention analysis',
      'Cohort comparisons',
      'Predictive insights',
    ],
    usageType: 'feature',
  },
  'predictive-analytics': {
    id: 'predictive-analytics',
    name: 'Predictive Performance Analytics',
    description: 'AI-powered forecasting of campaign performance trends',
    shortDescription: 'Performance forecasting',
    category: 'analytics',
    price: 54,
    billingPeriod: 'month',
    available: false,
    comingSoon: true,
    estimatedLaunch: 'Upcoming',
    benefits: ['Performance forecasting', 'Trend prediction', 'Budget planning', 'Risk assessment'],
    usageType: 'feature',
  },
};
